module.exports = __webpack_public_path__ + "static/media/html.b23cf012.png";